import { initFacetOverviewFilters } from '~/js/components/facet-overview-filters';

initFacetOverviewFilters( {
	sectionSelector: '.exp-article-overview',
	filterTargets: [
		'industry',
		'service',
		'topic',
		'postType',
		'event_location_city',
		'department',
		'workingArea',
	],
	urlPanelMappings: [
		{ param: '?_industries_filter', target: 'industry' },
		{ param: '?_working_areas_filter', target: 'workingArea' },
		{ param: '?_working_experiences_filter', target: 'workingExperience' },
		{ param: '?_services_filter', target: 'service' },
		{ param: '?_post_types_filter', target: 'postType' },
		{ param: '?_topics_filter', target: 'topic' },
		{ param: '?_departments_filter', target: 'department' },
		{ param: '?_inspiration_types_filter', target: 'inspirationType' },
	],
	bindMobileSearch: true,
} );
